import {lighten} from 'polished';
import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {colors} from 'theme';

export const StorageStatusTag = styled.div<{isActive: boolean}>`
    padding: 7px 10px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 4px;
    color: ${(p) => (p.isActive ? colors.success : colors.danger)};
    background-color: ${(p) =>
        p.isActive ? lighten(0.36, colors.success) : lighten(0.25, colors.danger)};
    cursor: default;
    white-space: nowrap;
`;

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
`;

export const SearchWrapper = styled.div`
    width: min(100%, 320px);
`;

export const CreateStorageButton = styled(Button)`
    width: auto;
    color: ${colors.white};

    > span {
        padding: 0 16px;
    }
`;

export const StorageNameButton = styled.button`
    padding: 0;
    border: 0;
    background: transparent;
    color: ${colors.brandPrimary};
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;
